const BASE_URL = 'https://mytraveljournalfinal.herokuapp.com'

export const API_URL = (slug) => `${BASE_URL}/${slug}`